// import React, { useState } from "react";
// import Adminnavbar from "./Adminnavbar";
// // import "./AdminUploadPage.css";

// export default function AdminUploadPage() {
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [category, setCategory] = useState("");
//   const [file, setFile] = useState(null);
//   const [uploads, setUploads] = useState([]);

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!title || !file) {
//       alert("Please add at least a title and file.");
//       return;
//     }

//     // Here you can call your API with formData
//     // const formData = new FormData();
//     // formData.append("title", title);
//     // formData.append("description", description);
//     // formData.append("category", category);
//     // formData.append("file", file);

//     // axios.post("/api/admin/upload", formData)

//     const newUpload = {
//       id: Date.now(),
//       title,
//       description,
//       category,
//       fileName: file.name,
//     };

//     setUploads([newUpload, ...uploads]);

//     // Clear form
//     setTitle("");
//     setDescription("");
//     setCategory("");
//     setFile(null);
//     e.target.reset();
//   };

//   return (
//     <>
//       <Adminnavbar />
//       <div className="page-wrapper page-settings">
//         <div className="content">
//           <div className="admin-upload-page">
//             {/* Top header / banner */}
//             <div className="upload-hero">
//               <div className="upload-hero-content">
//                 <div className="hero-icon-circle">⭳</div>
//                 <div>
//                   <h1 className="upload-hero-title">Admin Upload Center</h1>
//                   <p className="upload-hero-subtitle">
//                     Quickly upload documents, reports and media for your admin
//                     panel.
//                   </p>
//                 </div>
//               </div>

//               <div className="upload-stats">
//                 <div className="stat-item">
//                   <span className="stat-label">Total Uploads</span>
//                   <span className="stat-value">{uploads.length}</span>
//                 </div>
//                 <div className="stat-divider" />
//                 <div className="stat-item">
//                   <span className="stat-label">Status</span>
//                   <span className="stat-badge">Live</span>
//                 </div>
//               </div>
//             </div>

//             {/* Main content */}
//             <div className="admin-upload-layout">
//               {/* Form card */}
//               <div className="admin-upload-card">
//                 <div className="admin-upload-header">
//                   <h2>New File Upload</h2>
//                   <p>Fill in the details below and attach your file.</p>
//                 </div>

//                 <form className="admin-upload-form" onSubmit={handleSubmit}>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label htmlFor="title">
//                         File Title <span>*</span>
//                       </label>
//                       <input
//                         type="text"
//                         id="title"
//                         placeholder="e.g. March Sales Report"
//                         value={title}
//                         onChange={(e) => setTitle(e.target.value)}
//                       />
//                     </div>

//                     <div className="form-group">
//                       <label htmlFor="category">Category</label>
//                       <select
//                         id="category"
//                         value={category}
//                         onChange={(e) => setCategory(e.target.value)}
//                       >
//                         <option value="">Select category</option>
//                         <option value="document">Document</option>
//                         <option value="image">Image</option>
//                         <option value="report">Report</option>
//                         <option value="other">Other</option>
//                       </select>
//                     </div>
//                   </div>

//                   <div className="form-group">
//                     <label htmlFor="description">Description</label>
//                     <textarea
//                       id="description"
//                       rows="3"
//                       placeholder="Short description about the file (optional)"
//                       value={description}
//                       onChange={(e) => setDescription(e.target.value)}
//                     />
//                   </div>

//                   {/* File input styled as drop zone */}
//                   <div className="form-group">
//                     <label>
//                       Select File <span>*</span>
//                     </label>
//                     <div className="file-drop-area">
//                       <div className="file-drop-icon">📁</div>
//                       <div className="file-drop-text">
//                         <p className="file-drop-title">
//                           {file ? file.name : "Drag & drop or browse file"}
//                         </p>
//                         <p className="file-drop-sub">
//                           Allowed: images, PDF, DOC, XLS, etc.
//                         </p>
//                         <label htmlFor="file" className="file-browse-btn">
//                           Browse File
//                         </label>
//                       </div>
//                       <input
//                         type="file"
//                         id="file"
//                         onChange={(e) => setFile(e.target.files[0])}
//                       />
//                     </div>
//                   </div>

//                   <div className="form-actions">
//                     <button type="submit">Upload File</button>
//                   </div>
//                 </form>
//               </div>

//               {/* Right side: recent uploads */}
//               <div className="upload-list-card">
//                 <div className="upload-list-header">
//                   <h2>Recent Uploads</h2>
//                   <span className="upload-count-badge">
//                     {uploads.length} item{uploads.length !== 1 ? "s" : ""}
//                   </span>
//                 </div>

//                 {uploads.length === 0 ? (
//                   <div className="empty-state">
//                     <div className="empty-icon">📂</div>
//                     <p className="empty-title">No files uploaded yet</p>
//                     <p className="empty-text">
//                       Upload your first document to see it listed here.
//                     </p>
//                   </div>
//                 ) : (
//                   <ul className="upload-list">
//                     {uploads.map((item) => (
//                       <li key={item.id} className="upload-item">
//                         <div className="upload-timeline-dot" />
//                         <div className="upload-item-content">
//                           <div className="upload-item-main">
//                             <h3>{item.title}</h3>
//                             {item.category && (
//                               <span className="badge">{item.category}</span>
//                             )}
//                           </div>
//                           {item.description && (
//                             <p className="upload-desc">{item.description}</p>
//                           )}
//                           <div className="upload-meta-row">
//                             <p className="upload-file-name">
//                               File: <strong>{item.fileName}</strong>
//                             </p>
//                             <span className="upload-time-pill">Just now</span>
//                           </div>
//                         </div>
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }


import { useState } from "react";
import Adminnavbar from "./Adminnavbar";
// import "./AdminUploadPage.css";

export default function AdminUploadPage() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [file, setFile] = useState(null);
  const [uploads, setUploads] = useState([]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!title || !file) {
      alert("Please add at least a title and file.");
      return;
    }

    const newUpload = {
      id: Date.now(),
      title,
      description,
      category,
      fileName: file.name,
    };

    setUploads([newUpload, ...uploads]);

    // Clear form
    setTitle("");
    setDescription("");
    setCategory("");
    setFile(null);
    e.target.reset();
  };

  // ✅ Delete function
  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this file from the list?");
    if (!confirmDelete) return;

    setUploads((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <>
      <Adminnavbar />
      <div className="page-wrapper page-settings">
        <div className="content">

          <div className="admin-upload-page">
            {/* Top header / banner */}
            <div className="upload-hero">
              <div className="upload-hero-content">
                <div className="hero-icon-circle">⭳</div>
                <div>
                  <h1 className="upload-hero-title">Admin Upload Center</h1>
                  <p className="upload-hero-subtitle">
                    Quickly upload documents, reports and media for your admin panel.
                  </p>
                </div>
              </div>

              <div className="upload-stats">
                <div className="stat-item">
                  <span className="stat-label">Total Uploads</span>
                  <span className="stat-value">{uploads.length}</span>
                </div>
                <div className="stat-divider" />
                <div className="stat-item">
                  <span className="stat-label">Status</span>
                  <span className="stat-badge">Live</span>
                </div>
              </div>
            </div>

            {/* Main content */}
            <div className="admin-upload-layout">
              {/* Form card */}
              <div className="admin-upload-card">
                <div className="admin-upload-header">
                  <h2>New File Upload</h2>
                  <p>Fill in the details below and attach your file.</p>
                </div>

                <form className="admin-upload-form" onSubmit={handleSubmit}>
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="title">
                        File Title <span>*</span>
                      </label>
                      <input
                        type="text"
                        id="title"
                        placeholder="e.g. March Sales Report"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </div>

                    <div className="form-group">
                      <label htmlFor="category">Category</label>
                      <select
                        id="category"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                      >
                        <option value="">Select category</option>
                        <option value="document">Document</option>
                        <option value="image">Image</option>
                        <option value="report">Report</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <textarea
                      id="description"
                      rows="3"
                      placeholder="Short description about the file (optional)"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>

                  {/* File input styled as drop zone */}
                  <div className="form-group">
                    <label>
                      Select File <span>*</span>
                    </label>
                    <div className="file-drop-area">
                      <div className="file-drop-icon">📁</div>
                      <div className="file-drop-text">
                        <p className="file-drop-title">
                          {file ? file.name : "Drag & drop or browse file"}
                        </p>
                        <p className="file-drop-sub">
                          Allowed: images, PDF, DOC, XLS, etc.
                        </p>
                        <label htmlFor="file" className="file-browse-btn">
                          Browse File
                        </label>
                      </div>
                      <input
                        type="file"
                        id="file"
                        onChange={(e) => setFile(e.target.files[0])}
                      />
                    </div>
                  </div>

                  <div className="form-actions">
                    <button type="submit">Upload File</button>
                  </div>
                </form>
              </div>

              {/* Right side: recent uploads */}
              <div className="upload-list-card">
                <div className="upload-list-header">
                  <h2>Recent Uploads</h2>
                  <span className="upload-count-badge">
                    {uploads.length} item{uploads.length !== 1 ? "s" : ""}
                  </span>
                </div>

                {uploads.length === 0 ? (
                  <div className="empty-state">
                    <div className="empty-icon">📂</div>
                    <p className="empty-title">No files uploaded yet</p>
                    <p className="empty-text">
                      Upload your first document to see it listed here.
                    </p>
                  </div>
                ) : (
                  <ul className="upload-list">
                    {uploads.map((item) => (
                      <li key={item.id} className="upload-item">
                        <div className="upload-timeline-dot" />
                        <div className="upload-item-content">
                          <div className="upload-item-main">
                            <h3>{item.title}</h3>
                            {item.category && (
                              <span className="badge">{item.category}</span>
                            )}
                          </div>
                          {item.description && (
                            <p className="upload-desc">{item.description}</p>
                          )}
                          <div className="upload-meta-row">
                            <p className="upload-file-name">
                              File: <strong>{item.fileName}</strong>
                            </p>

                            {/* ✅ Delete button here */}
                            <div className="upload-actions">
                              <button
                                type="button"
                                className="upload-delete-btn"
                                onClick={() => handleDelete(item.id)}
                              >
                                Delete
                              </button>
                              <span className="upload-time-pill">Just now</span>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
